import { FormError, Header } from '@psyomics/ui-components';
import { type ReactNode } from 'react';
import { type UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { RespondentType } from './generated/referral-request';
import { PatientIdField } from './patient-id-field';
import { getFormErrorMessages, getRespondentErrorMessages } from './referral-request-form-utils';
import { type FormValues, RespondentFields } from './respondent-fields';

type ReferralRequestFormProps = {
  readonly service: { description: string; respondentTypes: RespondentType[] };
  readonly form: UseFormReturn<FormValues>;
  readonly renderActions: () => ReactNode;
  readonly disabled?: boolean;
};

const ReferralRequestForm = ({ service, form, renderActions: RenderActions, disabled }: ReferralRequestFormProps) => {
  const { t } = useTranslation();

  const {
    control,
    getValues,
    register,
    formState: { errors },
  } = form;

  const errorRequired = t('common.errors.required');
  const invalidMessage = t('auth.common.errors.phoneNumberInvalid');

  return (
    <form>
      <Header level="h2">{service.description}</Header>
      <PatientIdField disabled={disabled} register={register} />

      {service.respondentTypes.map((respondentType) => (
        <RespondentFields
          control={control}
          disabled={disabled}
          errorRequired={errorRequired}
          getValues={getValues}
          invalidMessage={invalidMessage}
          key={respondentType}
          register={register}
          respondentType={respondentType}
          {...getRespondentErrorMessages(errors, respondentType)}
        />
      ))}
      <FormError className="mt-4" error={getFormErrorMessages(errors, service.respondentTypes)} />
      <div className="flex gap-2 mt-4">
        <RenderActions />
      </div>
    </form>
  );
};

export { ReferralRequestForm };
